<template>
  <Navbar :title="title" :class="{'show': showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">Cerrar</div>
    </template>
    <template v-slot:content>
      <div class="form-section">
        <div class="form-section__title">Datos personales</div>
        <div class="form-group">
          <label for="staff-name">Nombre</label>
          <input v-model="form.name" class="input" type="text" id="staff-name" maxlength="100" placeholder="Nombre">
          <span v-if="errors.name" class="error">{{ errors.name }}</span>
        </div>
        <div class="form-group">
          <label for="staff-lastName">Apellido</label>
          <input v-model="form.lastName" class="input" type="text" id="staff-lastName" maxlength="100" placeholder="Apellido">
          <span v-if="errors.lastName" class="error">{{ errors.lastName }}</span>
        </div>
        <div class="form-group">
          <label for="staff-doc">DNI</label>
          <input v-model="form.document" class="input" type="text" id="staff-doc" maxlength="8" placeholder="12345678">
          <span v-if="errors.document" class="error">{{ errors.document }}</span>
        </div>
      </div>

      <div class="form-section">
        <div class="form-section__title">Contrato</div>
        <div class="form-group">
          <label for="staff-position">Cargo</label>
          <select v-model="form.positionSelect" class="select" id="staff-position">
            <option value="" disabled>Selecciona un cargo</option>
            <option v-for="c in cargoOptions" :key="c" :value="c">{{ c }}</option>
          </select>
          <span v-if="errors.position" class="error">{{ errors.position }}</span>
        </div>
        <div v-if="form.positionSelect === 'Otro'" class="form-group">
          <label for="staff-position-other">Especifica el cargo</label>
          <input v-model="form.positionOther" class="input" type="text" id="staff-position-other" maxlength="80" placeholder="Cargo">
        </div>
        <div class="form-group">
          <label for="staff-estate">Local</label>
          <select v-model="form.estateId" class="select" id="staff-estate">
            <option value="" disabled>Selecciona un local</option>
            <option v-for="e in estates" :key="e.id" :value="e.id">{{ e.description }}</option>
          </select>
          <span v-if="errors.estateId" class="error">{{ errors.estateId }}</span>
        </div>
        <div class="form-group">
          <label for="staff-type">Tipo de contrato</label>
          <select v-model="form.type" class="select" id="staff-type">
            <option value="fixed">Fijo — sueldo mensual</option>
            <option value="variable-hour">Variable — por hora</option>
            <option value="variable-day">Variable — por día</option>
          </select>
          <span v-if="errors.type" class="error">{{ errors.type }}</span>
        </div>
        <div v-if="form.type === 'fixed'" class="form-group">
          <label for="staff-salary">Sueldo mensual (S/)</label>
          <input v-model.number="form.monthlySalary" class="input" type="number" id="staff-salary" min="0" step="0.01">
          <span v-if="errors.monthlySalary" class="error">{{ errors.monthlySalary }}</span>
        </div>
        <div v-if="form.type && form.type !== 'fixed'" class="form-group">
          <label for="staff-rate">Tarifa (S/ por {{ form.type === 'variable-hour' ? 'hora' : 'día' }})</label>
          <input v-model.number="form.rate" class="input" type="number" id="staff-rate" min="0" step="0.01">
          <span v-if="errors.rate" class="error">{{ errors.rate }}</span>
        </div>
      </div>

      <!-- Datos de depósito (opcional) -->
      <div class="form-section">
        <div class="form-section__title">Pago</div>
        <div class="form-group">
          <label for="staff-pay-method">Forma de pago (opcional)</label>
          <select v-model="form.paymentMethod" class="select" id="staff-pay-method">
            <option value="">— Sin datos —</option>
            <option value="savings">Ahorros</option>
            <option value="checking">Corriente</option>
            <option value="yape">Yape</option>
            <option value="plin">Plin</option>
          </select>
          <span v-if="errors.method" class="error">{{ errors.method }}</span>
        </div>
        <template v-if="isAccountMethod">
          <div class="form-group">
            <label for="staff-bank">Banco</label>
            <select v-model="form.bankSelect" class="select" id="staff-bank">
              <option value="">Selecciona un banco</option>
              <option v-for="b in bankOptions" :key="b" :value="b">{{ b }}</option>
            </select>
          </div>
          <div v-if="form.bankSelect === 'Otro'" class="form-group">
            <label for="staff-bank-other">Nombre del banco</label>
            <input v-model="form.bankOther" class="input" type="text" id="staff-bank-other" maxlength="40" placeholder="Nombre del banco">
            <span v-if="errors.bank" class="error">{{ errors.bank }}</span>
          </div>
          <div class="form-group">
            <label for="staff-account">N° de cuenta</label>
            <input v-model="form.accountNumber" class="input" type="text" id="staff-account" maxlength="20" placeholder="Solo dígitos" inputmode="numeric">
            <span v-if="errors.accountNumber" class="error">{{ errors.accountNumber }}</span>
          </div>
          <div class="form-group">
            <label for="staff-cci">CCI</label>
            <input v-model="form.cci" class="input" type="text" id="staff-cci" maxlength="20" placeholder="20 dígitos" inputmode="numeric">
            <span v-if="errors.cci" class="error">{{ errors.cci }}</span>
          </div>
        </template>
        <div v-else-if="isWalletMethod" class="form-group">
          <label for="staff-phone">Celular</label>
          <input v-model="form.phone" class="input" type="text" id="staff-phone" maxlength="9" placeholder="9 dígitos" inputmode="numeric">
          <span v-if="errors.phone" class="error">{{ errors.phone }}</span>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button :disabled="progress" :class="{'is-loading': progress}" @click="save" class="btn">
        <span v-if="!progress">Guardar</span>
      </button>
    </template>
  </Navbar>
  <Shadow :class="{'show': showNavbar}"/>
</template>

<script>
import Navbar from '@/components/Navbar'
import Shadow from '@/components/Shadow'
import { db, FieldValue } from '@/firebase/firebaseConfig'
import * as yup from 'yup'
import { BANK_OPTIONS, CARGO_OPTIONS, resolvePosition, paymentSchema, buildPayment, paymentValues, isAccountMethod, isWalletMethod } from './paymentData'

yup.setLocale({
  mixed: { required: 'Este campo es obligatorio' },
  number: { positive: 'Debe ser mayor a 0', min: 'Debe ser mayor a 0' }
})

const baseSchema = {
  name: yup.string().max(100).required().label('Nombre'),
  lastName: yup.string().max(100).required().label('Apellido'),
  document: yup.string().matches(/^\d{8}$/, 'DNI debe tener 8 dígitos').required().label('DNI'),
  position: yup.string().max(80).required('Selecciona un cargo').label('Cargo'),
  estateId: yup.string().required('Selecciona un local').label('Local'),
  type: yup.string().oneOf(['fixed', 'variable-hour', 'variable-day']).required().label('Tipo')
}

export default {
  name: 'NewStaff',
  components: { Navbar, Shadow },
  props: {
    showNavbar: { type: Boolean, default: false },
    title: { type: String, default: 'Agregar personal' }
  },
  emits: ['close', 'created'],
  data () {
    return {
      form: this.blankForm(),
      estates: [],
      errors: {},
      progress: false,
      bankOptions: BANK_OPTIONS,
      cargoOptions: CARGO_OPTIONS
    }
  },
  computed: {
    isAccountMethod () { return isAccountMethod(this.form.paymentMethod) },
    isWalletMethod () { return isWalletMethod(this.form.paymentMethod) }
  },
  watch: {
    showNavbar (val) {
      if (val) {
        this.form = this.blankForm()
        this.errors = {}
        this.loadEstates()
      }
    }
  },
  methods: {
    blankForm () {
      return {
        positionSelect: '',
        positionOther: '',
        type: 'fixed',
        estateId: '',
        paymentMethod: '',
        bankSelect: '',
        bankOther: '',
        accountNumber: '',
        cci: '',
        phone: ''
      }
    },
    async loadEstates () {
      if (this.estates.length) return
      try {
        const snap = await db.collection('estates').orderBy('description').get()
        this.estates = snap.docs.map(d => ({ id: d.id, description: d.data().description }))
      } catch (e) {
        this.$toast.error('Error al cargar locales')
      }
    },
    async save () {
      try {
        this.progress = true
        this.errors = {}
        const schemaShape = { ...baseSchema }
        if (this.form.type === 'fixed') {
          schemaShape.monthlySalary = yup.number().positive().required().label('Sueldo')
        } else {
          schemaShape.rate = yup.number().positive().required().label('Tarifa')
        }
        Object.assign(schemaShape, paymentSchema)
        const schema = yup.object().shape(schemaShape)
        await schema.validate({ ...this.form, position: resolvePosition(this.form), ...paymentValues(this.form) }, { abortEarly: false })

        const isVariable = this.form.type !== 'fixed'
        const estate = this.estates.find(e => e.id === this.form.estateId)
        const payload = {
          name: this.form.name.trim(),
          lastName: this.form.lastName.trim(),
          document: this.form.document.trim(),
          position: resolvePosition(this.form),
          estate: { id: estate.id, description: estate.description },
          type: isVariable ? 'variable' : 'fixed',
          payment: buildPayment(this.form),
          active: true,
          createdAt: FieldValue.serverTimestamp(),
          updatedAt: FieldValue.serverTimestamp()
        }
        if (!isVariable) {
          payload.monthlySalary = this.form.monthlySalary
          payload.rate = 0
          payload.rateUnit = 'hour'
        } else {
          payload.monthlySalary = 0
          payload.rate = this.form.rate
          payload.rateUnit = this.form.type === 'variable-hour' ? 'hour' : 'day'
        }

        const docRef = await db.collection('staff').add(payload)
        this.$emit('created', { id: docRef.id, ...payload })
        this.$emit('close')
        this.$toast.success('Personal agregado')
      } catch (err) {
        if (err.inner) {
          err.inner.forEach(e => { if (e.path) this.errors[e.path] = e.message })
        } else {
          this.$toast.error('Error al guardar')
        }
      } finally {
        this.progress = false
      }
    }
  }
}
</script>
